import type { IBaseViewModel } from '@/engine/app/interfaces';
import type { ViewsService } from '@/engine/app/Views.service.ts';
import { useInjection } from 'inversify-react';
import { TYPES } from '@/engine/ioc';
import { type ViewEntity } from '@/engine/app/models/viewEntity/view.entity';
import { SceneItemKind } from '@/engine/app/interfaces.ts';

export const customIndicationKinds = [
  SceneItemKind.IndicatedAnnotation,
  SceneItemKind.IndicatedAreaMeasurement,
  SceneItemKind.IndicatedSplineMeasurement,
  SceneItemKind.IndicatedDistance,
  SceneItemKind.IndicatedAngle
];

export const getCustomIndications = (view: ViewEntity, kindCollection: Array<SceneItemKind>): Array<IBaseViewModel> => {
  const mergedIndications: Array<IBaseViewModel> = [...view.getObjects(), ...view.getMeasurements()];
  return kindCollection
    .map((collection) => {
      return mergedIndications.filter((i) => i.kind === collection && i.isAvailable);
    })
    .flat();
};

export const useCustomIndications = (
  kindCollection: Array<SceneItemKind>
): { customIndications: Array<IBaseViewModel> } => {
  const { currentView }: ViewsService = useInjection<ViewsService>(TYPES.ViewsService);

  if (!currentView) {
    throw new Error('View should be defined by current step');
  }

  return { customIndications: getCustomIndications(currentView, kindCollection) };
};
